import { render, staticRenderFns } from "./staffUserModal.vue?vue&type=template&id=208a55af&"
import script from "./staffUserModal.vue?vue&type=script&lang=js&"
export * from "./staffUserModal.vue?vue&type=script&lang=js&"
import style0 from "./staffUserModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports